(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-story-carousel-v3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.bsInit === 'true') return;
      root.dataset.bsInit = 'true';
      var slides = Array.prototype.slice.call(root.querySelectorAll('.brand-story-v3__slide'));
      if (slides.length < 2) return;
      var counter = root.querySelector('[data-bs-current]');
      var prevBtn = root.querySelector('[data-bs-prev]');
      var nextBtn = root.querySelector('[data-bs-next]');
      var stage = root.querySelector('.brand-story-v3__stage');
      var loop = root.dataset.loop !== 'false';
      var pauseHover = root.dataset.pauseHover === 'true';
      var interval = parseInt(root.dataset.interval, 10) || 6000;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = root.dataset.autoplay === 'true' && !reducedMotion;
      var i = 0;
      var timer = null;

      function pad(n) {
        return n < 9 ? '0' + (n + 1) : '' + (n + 1);
      }
      function setVideo(slide, on) {
        var v = slide.querySelector('video');
        if (!v) return;
        if (on) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      }
      function go(n) {
        if (loop) {
          n = (n + slides.length) % slides.length;
        } else {
          n = Math.max(0, Math.min(slides.length - 1, n));
        }
        slides.forEach(function (s, idx) {
          var on = idx === n;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          setVideo(s, on);
        });
        i = n;
        if (counter) counter.textContent = pad(n);
        if (!loop) {
          if (prevBtn) prevBtn.disabled = n === 0;
          if (nextBtn) nextBtn.disabled = n === slides.length - 1;
        }
      }
      function next() { go(i + 1); }
      function prev() { go(i - 1); }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }
      function start() {
        stop();
        if (autoplay) timer = setInterval(next, interval);
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { next(); start(); }
        if (e.key === 'ArrowLeft') { prev(); start(); }
      });
      if (pauseHover) {
        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', start);
      }
      if (stage) {
        var sx = 0;
        stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 40) {
            if (dx < 0) { next(); } else { prev(); }
            start();
          }
        });
      }

      slides.forEach(function (s, idx) { setVideo(s, idx === 0); });
      if (!loop) {
        if (prevBtn) prevBtn.disabled = true;
        if (nextBtn) nextBtn.disabled = slides.length < 2;
      }
      start();

      root.brandStoryGo = go;
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.brand-story-v3').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest ? e.target.closest('.brand-story-v3__slide') : null;
      if (!slide) return;
      var root = slide.closest('.brand-story-v3');
      if (!root || typeof root.brandStoryGo !== 'function') return;
      var idx = Array.prototype.indexOf.call(root.querySelectorAll('.brand-story-v3__slide'), slide);
      if (idx > -1) root.brandStoryGo(idx);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nou-drop-countdown-1"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function tick(el) {
      const launch = new Date(el.dataset.launch);
      const now = new Date();
      let diff = Math.max(0, launch - now);
      const days = Math.floor(diff / 86400000); diff -= days * 86400000;
      const hours = Math.floor(diff / 3600000); diff -= hours * 3600000;
      const mins = Math.floor(diff / 60000); diff -= mins * 60000;
      const secs = Math.floor(diff / 1000);
      const set = (u, v) => { const n = el.querySelector('[data-unit="'+u+'"]'); if (n) n.textContent = String(v).padStart(2, '0'); };
      set('days', days); set('hours', hours); set('mins', mins); set('secs', secs);
    }
    document.querySelectorAll('.nou-drop-1').forEach(function (el) {
      tick(el); setInterval(function () { tick(el); }, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nou-drop-countdown-2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function tick(el) {
      const launch = new Date(el.dataset.launch);
      const now = new Date();
      let diff = Math.max(0, launch - now);
      const days = Math.floor(diff / 86400000); diff -= days * 86400000;
      const hours = Math.floor(diff / 3600000); diff -= hours * 3600000;
      const mins = Math.floor(diff / 60000); diff -= mins * 60000;
      const secs = Math.floor(diff / 1000);
      const set = (u, v) => { const n = el.querySelector('[data-unit="'+u+'"]'); if (n) n.textContent = String(v).padStart(2, '0'); };
      set('days', days); set('hours', hours); set('mins', mins); set('secs', secs);
    }
    document.querySelectorAll('.nou-drop-2').forEach(function (el) {
      tick(el); setInterval(function () { tick(el); }, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nou-waitlist-test"] && !Shopify.designMode) return;
  try {
    
/* nou — Waitlist (self-contained)
   Submits directly to Klaviyo Client Subscriptions API.
   Includes phone (E.164 normalized) when provided. */
(function () {
  if (window.__nouWaitlistInit) return;
  window.__nouWaitlistInit = true;

  var KLAVIYO_COMPANY_ID = 'TE6bVJ';
  var KLAVIYO_LIST_ID = 'WwXyZx'; // SHOP NOU
  var KLAVIYO_API = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID;
  var KLAVIYO_REVISION = '2024-10-15';

  function normalizePhone(raw) {
    if (!raw) return null;
    var digits = String(raw).replace(/\D/g, '');
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    return null;
  }

  function getOverlay(id) { return document.querySelector('[data-nou-waitlist="' + id + '"]'); }

  function openOverlay(id) {
    var overlay = getOverlay(id);
    if (!overlay) return;
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    var modal = overlay.querySelector('.nou-waitlist-modal');
    if (modal) modal.focus();
  }

  function closeOverlay(overlay) {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    setTimeout(function () { overlay.hidden = true; }, 200);
    document.body.style.overflow = '';
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.nou-waitlist-overlay.is-open');
    if (open) closeOverlay(open);
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-nou-waitlist-open]');
    if (trigger) { e.preventDefault(); openOverlay(trigger.dataset.nouWaitlistOpen); return; }
    var closer = e.target.closest('[data-nou-waitlist-close]');
    if (closer) { e.preventDefault(); closeOverlay(closer.closest('.nou-waitlist-overlay')); return; }
    if (e.target.classList && e.target.classList.contains('nou-waitlist-overlay')) { closeOverlay(e.target); return; }
  });

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-nou-waitlist-size]');
    if (!chip) return;
    var pressed = chip.getAttribute('aria-pressed') === 'true';
    chip.setAttribute('aria-pressed', pressed ? 'false' : 'true');
    chip.classList.toggle('is-selected', !pressed);
    var form = chip.closest('form');
    if (!form) return;
    var sizesInput = form.querySelector('[data-nou-waitlist-sizes]');
    if (!sizesInput) return;
    var values = [];
    form.querySelectorAll('[data-nou-waitlist-size][aria-pressed="true"]').forEach(function (el) {
      values.push(el.getAttribute('data-nou-waitlist-size'));
    });
    sizesInput.value = values.join(', ');
  });

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nou-waitlist-phone-toggle]');
    if (!toggle) return;
    var form = toggle.closest('form');
    var reveal = form ? form.querySelector('[data-nou-waitlist-phone-reveal]') : null;
    if (!reveal) return;
    var isOpen = !reveal.hidden && reveal.classList.contains('is-open');
    if (isOpen) {
      reveal.classList.remove('is-open');
      setTimeout(function () { reveal.hidden = true; }, 200);
      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.remove('is-open');
      toggle.textContent = 'want a text too?';
    } else {
      reveal.hidden = false;
      requestAnimationFrame(function () { reveal.classList.add('is-open'); });
      toggle.setAttribute('aria-expanded', 'true');
      toggle.classList.add('is-open');
      toggle.textContent = 'hide phone';
      var phone = reveal.querySelector('[data-nou-waitlist-phone]');
      if (phone) setTimeout(function () { phone.focus(); }, 220);
    }
  });

  function gatherProperties(form) {
    var props = {};
    var source = form.getAttribute('data-source');
    if (source) props.signup_source = source;
    form.querySelectorAll('input[name^="properties["]').forEach(function (input) {
      var match = input.name.match(/^properties\[([^\]]+)\]$/);
      if (!match) return;
      var key = match[1];
      var value = (input.value || '').trim();
      if (value) props[key] = value;
    });
    return props;
  }

  function showError(form, msg) {
    var errEl = form.querySelector('.nou-waitlist-error');
    if (!errEl) {
      errEl = document.createElement('div');
      errEl.className = 'nou-waitlist-error';
      errEl.setAttribute('role', 'alert');
      form.appendChild(errEl);
    }
    errEl.textContent = msg;
  }

  function showSuccess(form, summary) {
    var msg = form.getAttribute('data-success') || "you're on the list.";
    var wrap = document.createElement('div');
    wrap.className = 'nou-waitlist-success';
    wrap.setAttribute('role', 'status');
    var heading = document.createElement('p');
    heading.className = 'nou-waitlist-success-title';
    heading.textContent = msg;
    wrap.appendChild(heading);
    var dl = document.createElement('dl');
    dl.className = 'nou-waitlist-success-meta';
    Object.keys(summary).forEach(function (k) {
      var dt = document.createElement('dt'); dt.textContent = k;
      var dd = document.createElement('dd'); dd.textContent = summary[k];
      dl.appendChild(dt); dl.appendChild(dd);
    });
    wrap.appendChild(dl);
    form.replaceWith(wrap);
    var overlay = wrap.closest('.nou-waitlist-overlay');
    if (overlay) setTimeout(function () { closeOverlay(overlay); }, 1600);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-nou-waitlist-form]');
    if (!form) return;
    e.preventDefault();

    var emailInput = form.querySelector('input[type="email"]');
    if (!emailInput || !emailInput.value) { showError(form, 'Please enter a valid email.'); return; }
    var phoneInput = form.querySelector('input[type="tel"]');
    var phone = phoneInput ? normalizePhone(phoneInput.value) : null;
    var email = emailInput.value.trim();
    var properties = gatherProperties(form);
    var source = form.getAttribute('data-source') || 'waitlist';

    var profileAttrs = { email: email };
    if (phone) {
      profileAttrs.phone_number = phone;
      profileAttrs.subscriptions = {
        email: { marketing: { consent: 'SUBSCRIBED' } },
        sms: { marketing: { consent: 'SUBSCRIBED' } }
      };
    }
    if (Object.keys(properties).length) profileAttrs.properties = properties;

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
      }
    };

    var submitBtn = form.querySelector('button[type="submit"]');
    var origLabel = submitBtn ? submitBtn.textContent : null;
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Submitting…'; }

    fetch(KLAVIYO_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (res.status === 202 || (res.status >= 200 && res.status < 300)) {
        var summary = { 'email': email };
        if (properties.sizes_interested) summary['size'] = properties.sizes_interested;
        if (phone) summary['text alerts'] = 'on';
        showSuccess(form, summary);
      } else {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origLabel; }
        showError(form, 'Something went wrong. Please try again.');
      }
    }).catch(function () {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origLabel; }
      showError(form, 'Network error. Please try again.');
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
